<div class="modal-header">
    <h5 class="modal-title text-truncate" data-uiid="documentmanagerdetails-title">
        {{ !Document.ID && !Document.IsNew ? "Add document" : "Edit " + Document.Name }}
    </h5>
</div>
<div class="modal-body">
    <ul class="nav nav-tabs">
        <li class="nav-item {{ selectedTab == 'details' ? 'active' : '' }}">
            <button
                class="nav-link {{ selectedTab == 'details' ? 'active' : '' }}"
                data-toggle="tab"
                (click)="toggle('details')"
            >
                Document details
            </button>
        </li>
        @if (Document && Document.ID > 0) {
            <li class="nav-item {{ selectedTab == 'history' ? 'active' : '' }}">
                <button
                    class="nav-link {{ selectedTab == 'history' ? 'active' : '' }}"
                    data-uiid="documentmanagerdetails-history-tab"
                    data-toggle="tab"
                    (click)="toggle('history')"
                >
                    History
                </button>
            </li>
        }
    </ul>
    <div class="tab-content">
        <div
            class="tab-pane {{ selectedTab == 'details' ? 'active' : '' }}"
            id="documentDetail"
            #documentDetail
        >
            <form novalidate [formGroup]="documentForm">
                <div class="row">
                    <div class="form-group col">
                        <label>File{{ !Document.ID ? "(s)" : "" }}</label>
                        <div class="input-group">
                            <input
                                data-uiid="documentmanagerdetails-filename"
                                type="text"
                                class="form-control"
                                formControlName="file"
                                [value]="
                                    fileInputCount > 1 ? fileInputCount + ' files' : fileInputText
                                "
                                [title]="fileInputText"
                                inputTooltip
                            />
                            <input
                                data-uiid="documentmanagerdetails-fileinput"
                                type="file"
                                id="fileUpload"
                                [accept]="AllowedFileExtensions"
                                [multiple]="!Document.ID && !SingleFileUpload"
                                [hidden]="true"
                                (change)="updateFiles()"
                                #fileInput
                            />
                            @if ((!Document.ID && AllowAdd) || (Document.ID > 0 && AllowEdit)) {
                                <div class="input-group-append">
                                    <button
                                        data-uiid="documentmanagerdetails-browsebutton"
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        (click)="openFileSelect()"
                                    >
                                        <i
                                            class="fas fa-{{
                                                fileInputText.length === 0
                                                    ? 'folder-plus'
                                                    : 'sync-alt'
                                            }}"
                                            aria-hidden="true"
                                        ></i>
                                        <span class="d-none d-lg-inline ms-2">Browse</span>
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div class="row">
                    @if (ShowType && documentTypes) {
                        <div class="form-group col">
                            <label for="documentTypeSelect">Document type</label>
                            <ng-select
                                data-uiid="documentmanagerdetails-documenttype"
                                id="documentTypeSelect"
                                name="documentTypeSelect"
                                [items]="documentTypes"
                                formControlName="DocumentType"
                                bindLabel="Name"
                                bindValue="ID"
                                [closeOnSelect]="true"
                                [multiple]="false"
                            >
                            </ng-select>
                        </div>
                    }
                </div>

                @if (ShowDescription) {
                    <div class="row">
                        <div class="form-group col">
                            <label for="descriptionInput">Description</label>
                            <cerrix-textarea
                                errorLabel="Description"
                                dataUiid="documentmanagerdetails-description"
                                identifier="descriptionInput"
                                [rows]="10"
                                formControlName="Description"
                            ></cerrix-textarea>
                        </div>
                    </div>
                }

                @if (showPdfButton) {
                    <div class="row">
                        <div class="offset-sm-3 col-sm-9">
                            <a class="pdfLink" (click)="openDocumentViewer()"
                                >Open PDF in document viewer</a
                            >
                        </div>
                    </div>
                }
            </form>
        </div>
        @if (Document && Document.ID > 0) {
            <div
                class="tab-pane {{ selectedTab == 'history' ? 'active' : '' }}"
                id="history"
                #history
            >
                <document-history [guid]="Document.Guid"></document-history>
            </div>
        }
    </div>
</div>
<div class="modal-footer">
    <div class="justify-start">
        @if (validationModel) {
            @if (validationModel.isValid) {
                <label style="color: #1bb642">
                    <i class="fa-regular fa-circle-check" style="color: #1bb642"></i> File is
                    valid</label
                >
            } @else if (validationModel.isValid !== null) {
                <label style="color: #c91818">
                    <i class="fa-regular fa-circle-xmark" style="color: #c91818"></i> File is
                    invalid</label
                >
            }
        }
    </div>
    @if (showValidationBtn) {
        <button class="btn" (click)="validateClick(Document)">Validate</button>
    }
    @if ((!Document.ID && AllowAdd) || (Document.ID > 0 && AllowEdit)) {
        <button
            data-uiid="documentmanagerdetails-adddocumentsbutton"
            type="button"
            class="btn btn-primary"
            [disabled]="disabled || fileInputText.length === 0"
            (click)="applyChange()"
        >
            {{ Document.ID || Document.IsNew ? "Apply changes" : "Add document(s)" }}
        </button>
    }
    <button class="btn btn-secondary" (click)="closeClick()">Cancel</button>
</div>
